import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { SiteBackground } from "./components/SiteBackground";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { LanguagesStrip } from "./components/LanguagesStrip";
import { TargetAudience } from "./components/TargetAudience";
import { Testimonial } from "./components/Testimonial";
import { Ticker } from "./components/Ticker";
import { Workflow } from "./components/Workflow";
import { Features } from "./components/Features";
import { ScreenshotStrip } from "./components/ScreenshotStrip";
import { Pricing } from "./components/Pricing";
import { FAQ } from "./components/FAQ";
import { IdeanSynty } from "./components/IdeanSynty";
import { Contact } from "./components/Contact";
import { GetStarted } from "./components/GetStarted";
import { TrustBar } from "./components/TrustBar";
import { Footer } from "./components/Footer";
import Kayttoehdot from "./components/legal/Kayttoehdot";
import Tietosuojaseloste from "./components/legal/Tietosuojaseloste";
import OgGenerator from "./components/OgGenerator";

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/kayttoehdot" element={<Kayttoehdot />} />
          <Route path="/tietosuojaseloste" element={<Tietosuojaseloste />} />
          <Route path="/og-generator" element={<OgGenerator />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

function Landing() {
  return (
    <div className="App relative bg-[#0F0F0F] text-white min-h-screen" data-testid="landing-root">
      <SiteBackground />
      <div className="relative" style={{ zIndex: 1 }}>
        <Header />
        <main>
          <Hero />
          <Ticker />
          <Workflow />
          <Features />
          <ScreenshotStrip />
          <GetStarted />
          <LanguagesStrip />
          <TargetAudience />
          <Pricing />
          <Testimonial />
          <FAQ />
          <IdeanSynty />
          <Contact />
        </main>
        <TrustBar />
        <Footer />
      </div>
    </div>
  );
}
